import { render, staticRenderFns } from "./PostFormDetail.vue?vue&type=template&id=5a515256&scoped=true"
import script from "./PostFormDetail.vue?vue&type=script&lang=js"
export * from "./PostFormDetail.vue?vue&type=script&lang=js"
import style0 from "./PostFormDetail.vue?vue&type=style&index=0&id=5a515256&prod&scoped=true&lang=css"
import style1 from "./PostFormDetail.vue?vue&type=style&index=1&id=5a515256&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a515256",
  null
  
)

export default component.exports